import { RootState } from 'store/rootSlices';

export const getUserNmec = (state: RootState) => state.App.user.nmec;
export const getUser = (state: RootState) => state.App.user;
export const getGradeHistorySlice = (state: RootState) => state.GradesHistory;
export const getGradeHistory = (state: RootState) => state.GradesHistory.historyList;
